import { createTheme } from "@mui/material/styles";

/**
 * Cohesive theme for the v2 admin — Inter-first sans stack, slate-blue accent, soft surfaces.
 * Used by the AppBar, list filters, MUI Dialog (NoteModal), Tabs, etc.
 */
const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#0f172a", contrastText: "#ffffff" },
    secondary: { main: "#2563eb" },
    success: { main: "#16a34a" },
    warning: { main: "#d97706" },
    error: { main: "#dc2626" },
    background: { default: "#f7f8fa", paper: "#ffffff" },
    divider: "#e5e7eb",
    text: { primary: "#0f172a", secondary: "#475569" },
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily:
      'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    h5: { fontWeight: 700, letterSpacing: "-0.01em" },
    h6: { fontWeight: 600 },
    subtitle1: { fontWeight: 600 },
    button: { fontWeight: 600, letterSpacing: 0 },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true, disableRipple: false },
      styleOverrides: {
        root: { textTransform: "none", borderRadius: 8 },
        sizeSmall: { paddingInline: 12 },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: { textTransform: "none", fontWeight: 600, minHeight: 44 },
      },
    },
    MuiTabs: { styleOverrides: { indicator: { height: 3, borderRadius: 3 } } },
    MuiPaper: {
      styleOverrides: { rounded: { borderRadius: 12 } },
    },
    MuiCard: { styleOverrides: { root: { borderRadius: 12 } } },
    MuiAppBar: {
      styleOverrides: {
        root: { boxShadow: "0 1px 0 rgba(15,23,42,0.06)" },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 8 },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        sizeSmall: { fontSize: 14 },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 600, borderRadius: 6 },
        sizeSmall: { height: 22 },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: { borderRadius: 14 },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: { fontSize: 12, fontWeight: 500 },
      },
    },
  },
});

export default theme;
